// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getOpenOrderVM(order, order_fare) {
  var data = order_fare.fare_details.customer;
  return {
          created_time: Timestamp$Catalyst.toString(order.created_at, "DD/MM/YY hh:mm A"),
          scheduled_pickup_time: Timestamp$Catalyst.toString(order.scheduled_pickup_time, "DD/MM/YY hh:mm A"),
          accepted_time: "N/A",
          pickup_time: "N/A",
          start_time: "N/A",
          trip_end_time: "N/A",
          job_end_time: "N/A",
          cancelled_time: "N/A",
          check_wait_time: data !== undefined ? String(data.breakup_details.waiting_time) + " Mins" : String(order_fare.fare_details.estimated.breakup_details.waiting_time) + " Mins"
        };
}

function getAcceptedOrderVm(order, accepted_order, order_fare) {
  var init = getOpenOrderVM(order, order_fare);
  var time = accepted_order.trip_accepted_time;
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD/MM/YY hh:mm A") : "N/A",
          pickup_time: Timestamp$Catalyst.toString(order.pickup_time, "DD/MM/YY hh:mm A"),
          start_time: init.start_time,
          trip_end_time: init.trip_end_time,
          job_end_time: init.job_end_time,
          cancelled_time: init.cancelled_time,
          check_wait_time: init.check_wait_time
        };
}

function getLiveOrderVm(order, accepted_order, started_order, order_fare) {
  var init = getAcceptedOrderVm(order, accepted_order, order_fare);
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: init.accepted_time,
          pickup_time: init.pickup_time,
          start_time: Timestamp$Catalyst.toString(started_order.trip_started_time, "DD/MM/YY hh:mm A"),
          trip_end_time: init.trip_end_time,
          job_end_time: init.job_end_time,
          cancelled_time: init.cancelled_time,
          check_wait_time: init.check_wait_time
        };
}

function getCancelledOrderVm(order, cancelled_order, order_fare) {
  var init = getOpenOrderVM(order, order_fare);
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: init.accepted_time,
          pickup_time: init.pickup_time,
          start_time: init.start_time,
          trip_end_time: init.trip_end_time,
          job_end_time: init.job_end_time,
          cancelled_time: Timestamp$Catalyst.toString(cancelled_order.trip_cancelled_time, "DD/MM/YY hh:mm A"),
          check_wait_time: init.check_wait_time
        };
}

function getCancelledAcceptedOrderVm(order, accepted_order, cancelled_order, order_fare) {
  var init = getAcceptedOrderVm(order, accepted_order, order_fare);
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: init.accepted_time,
          pickup_time: init.pickup_time,
          start_time: init.start_time,
          trip_end_time: init.trip_end_time,
          job_end_time: init.job_end_time,
          cancelled_time: Timestamp$Catalyst.toString(cancelled_order.trip_cancelled_time, "DD/MM/YY hh:mm A"),
          check_wait_time: init.check_wait_time
        };
}

function getCancelledLiveOrderVm(order, accepted_order, started_order, cancelled_order, order_fare) {
  var init = getLiveOrderVm(order, accepted_order, started_order, order_fare);
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: init.accepted_time,
          pickup_time: init.pickup_time,
          start_time: init.start_time,
          trip_end_time: init.trip_end_time,
          job_end_time: init.job_end_time,
          cancelled_time: Timestamp$Catalyst.toString(cancelled_order.trip_cancelled_time, "DD/MM/YY hh:mm A"),
          check_wait_time: init.check_wait_time
        };
}

function getEndedOrderVm(order, accepted_order, started_order, ended_order, order_fare) {
  var init = getLiveOrderVm(order, accepted_order, started_order, order_fare);
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: init.accepted_time,
          pickup_time: init.pickup_time,
          start_time: init.start_time,
          trip_end_time: Timestamp$Catalyst.toString(ended_order.trip_end_time, "DD/MM/YY hh:mm A"),
          job_end_time: Belt_Option.mapWithDefault(ended_order.job_end_time, "N/A", (function (t) {
                  return Timestamp$Catalyst.toString(t, "DD/MM/YY hh:mm A");
                })),
          cancelled_time: init.cancelled_time,
          check_wait_time: init.check_wait_time
        };
}

function getCancelledCompletedOrderVm(order, started_order, accepted_order, cancelled_order, ended_order, order_fare) {
  var init = getCancelledOrderVm(order, cancelled_order, order_fare);
  var time = accepted_order.trip_accepted_time;
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD/MM/YY hh:mm A") : "N/A",
          pickup_time: Timestamp$Catalyst.toString(order.pickup_time, "DD/MM/YY hh:mm A"),
          start_time: Timestamp$Catalyst.toString(started_order.trip_started_time, "DD/MM/YY hh:mm A"),
          trip_end_time: Timestamp$Catalyst.toString(ended_order.trip_end_time, "DD/MM/YY hh:mm A"),
          job_end_time: Belt_Option.mapWithDefault(ended_order.job_end_time, "N/A", (function (t) {
                  return Timestamp$Catalyst.toString(t, "DD/MM/YY hh:mm A");
                })),
          cancelled_time: init.cancelled_time,
          check_wait_time: init.check_wait_time
        };
}

function getCancelledEnderOrderVm(order, started_order, accepted_order, cancelled_order, ended_order, order_fare) {
  var init = getCancelledOrderVm(order, cancelled_order, order_fare);
  var time = accepted_order.trip_accepted_time;
  return {
          created_time: init.created_time,
          scheduled_pickup_time: init.scheduled_pickup_time,
          accepted_time: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD/MM/YY hh:mm A") : "N/A",
          pickup_time: Timestamp$Catalyst.toString(order.pickup_time, "DD/MM/YY hh:mm A"),
          start_time: Timestamp$Catalyst.toString(started_order.trip_started_time, "DD/MM/YY hh:mm A"),
          trip_end_time: Timestamp$Catalyst.toString(ended_order.trip_end_time, "DD/MM/YY hh:mm A"),
          job_end_time: Belt_Option.mapWithDefault(ended_order.job_end_time, "N/A", (function (t) {
                  return Timestamp$Catalyst.toString(t, "DD/MM/YY hh:mm A");
                })),
          cancelled_time: init.cancelled_time,
          check_wait_time: init.check_wait_time
        };
}

function getVm(order, order_fare) {
  switch (order.TAG | 0) {
    case /* Open */0 :
        return getOpenOrderVM(order._0, order_fare);
    case /* Accepted */1 :
        return getAcceptedOrderVm(order._0, order._1, order_fare);
    case /* Live */2 :
        return getLiveOrderVm(order._0, order._1, order._2, order_fare);
    case /* Ended */3 :
        return getEndedOrderVm(order._0, order._1, order._2, order._3, order_fare);
    case /* Cancelled */4 :
        return getCancelledOrderVm(order._0, order._1, order_fare);
    case /* CancelledAccepted */5 :
        return getCancelledAcceptedOrderVm(order._0, order._2, order._1, order_fare);
    case /* CancelledLive */6 :
        return getCancelledLiveOrderVm(order._0, order._2, order._3, order._1, order_fare);
    case /* CancelledCompleted */7 :
        return getCancelledCompletedOrderVm(order._0, order._1, order._2, order._3, order._4, order_fare);
    case /* CancelledEnded */8 :
        return getCancelledEnderOrderVm(order._0, order._1, order._2, order._3, order._4, order_fare);
    
  }
}

export {
  getOpenOrderVM ,
  getAcceptedOrderVm ,
  getLiveOrderVm ,
  getCancelledOrderVm ,
  getCancelledAcceptedOrderVm ,
  getCancelledLiveOrderVm ,
  getEndedOrderVm ,
  getCancelledCompletedOrderVm ,
  getCancelledEnderOrderVm ,
  getVm ,
  
}
/* Timestamp-Catalyst Not a pure module */
